import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import NavigationHeader from './NavigationHeader';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import BusinessHoursSection from './BusinessHoursSection';
import ServicesSection from './ServicesSection';
import PhotoGallery from './PhotoGallery';
import TestimonialsSection from './TestimonialsSection';
import GMBFeedSection from './GMBFeedSection';
import LocationSection from './LocationSection';
import CategoryTagsSection from './CategoryTagsSection';
import RelatedServicesSection from './RelatedServicesSection';
import Footer from './Footer';
import { LocalBusinessSchema } from '../SchemaScript';
import extractSchemaData from '../../utils/extractSchemaData';

// Premium Google Fonts for Glassmorphism Design
const GoogleFontsLink = () => (
  <link
    href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700&display=swap"
    rel="stylesheet"
  />
);

const TemplateContainer = styled(Box)({
  width: '100%',
  minHeight: '100vh',
  backgroundColor: '#ffffff',
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  overflowX: 'hidden'
});

const Template8 = ({
  templateData,
  isEditable = false,
  onTemplateUpdate
}) => {
  const {
    businessInfo,
    services,
    products,
    photos,
    testimonials,
    contactInfo,
    location,
    gmbFeed,
    businessHours,
    socialMedia,
    categories,
    keywordsData
  } = templateData || {};

  const hasBusinessInfo = businessInfo?.name;
  const hasServices = services && services.length > 0;
  const hasProducts = products && products.length > 0;
  const hasPhotos = photos && photos.length > 0;
  const hasTestimonials = testimonials && testimonials.length > 0;
  const hasContactInfo = contactInfo && (contactInfo.address || contactInfo.phone);
  const hasGMBFeed = gmbFeed && ((gmbFeed.posts && gmbFeed.posts.length > 0) || (Array.isArray(gmbFeed) && gmbFeed.length > 0));

  // Extract schema data for LocalBusiness structured data
  const schemaData = extractSchemaData(templateData);

  return (
    <>
      <GoogleFontsLink />
      {schemaData && <LocalBusinessSchema business={schemaData} />}
      <TemplateContainer>
        {hasBusinessInfo && (
          <NavigationHeader businessInfo={businessInfo} contactInfo={contactInfo} />
        )}

        {hasBusinessInfo && (
          <HeroSection
            businessInfo={businessInfo}
            heroImage={hasPhotos ? photos[0]?.url : null}
            contactInfo={contactInfo}
          />
        )}

        {hasBusinessInfo && (
          <AboutSection
            businessInfo={businessInfo}
            contactInfo={contactInfo}
          />
        )}

        {(hasServices || hasProducts) && (
          <ServicesSection
            services={services}
            products={products}
          />
        )}

        {hasPhotos && (
          <PhotoGallery photos={photos} />
        )}

        {hasTestimonials && (
          <TestimonialsSection testimonials={testimonials} />
        )}

        {hasGMBFeed && (
          <GMBFeedSection gmbFeed={Array.isArray(gmbFeed) ? gmbFeed : gmbFeed.posts} />
        )}

        <BusinessHoursSection
          businessHours={businessHours}
          contactInfo={contactInfo}
        />

        {hasContactInfo && (
          <LocationSection
            location={location}
            contactInfo={contactInfo}
          />
        )}

        <CategoryTagsSection
          businessInfo={businessInfo}
          categories={categories}
          services={services}
          products={products}
          keywordsData={keywordsData}
        />

        <RelatedServicesSection
          businessInfo={businessInfo}
          contactInfo={contactInfo}
          categories={categories}
          currentSlug={templateData?.slug}
        />

        <Footer
          businessInfo={businessInfo}
          socialMedia={socialMedia}
        />
      </TemplateContainer>
    </>
  );
};

export default Template8;
